export enum FilterGroupName {
  CATEGORY1 = "CATEGORY1",
  THEME = "THEME",
  LIFE_STYLE = "LIFE_STYLE",
  SPACE = "SPACE",
}
